import { Divider } from "@mui/material";

function DashboardCard(props) {
  let data = props.list;
  let usersList = [];
  if (props.expanded === false) {
    if (data.length > 3) {
      for (let index = 0; index < 3; index++) {
        const element = data[index];
        usersList.push(element);
      }
    } else {
      for (let index = 0; index < data.length; index++) {
        const element = data[index];
        usersList.push(element);
      }
    }
  } else {
    for (let index = 0; index < data.length; index++) {
      const element = data[index];
      usersList.push(element);
    }
  }

  return (
    <div className="anim">
      <div
        className="dashboard-card"
        onClick={() => {
          props.onClick();
        }}
      >
        <div>
          <h2>{props.title}</h2>
          <p style={{ fontStyle: "normal", fontWeight: "normal" }}>
            {props.description}
          </p>
        </div>
        <h3 style={{ margin: "0" }}>
          {props.expanded === false ? "Top 3" : "All Visitors"}
        </h3>
      </div>
      {usersList.map((key) => (
        <div style={{ padding: "0 10px" }}>
          <div
            style={{
              display: "flex",
              alignItems: "center",
              justifyContent: "space-between",
            }}
          >
            <div style={{ display: "flex", alignItems: "center", gap: "30px" }}>
              <h4>{key.visitor.name}</h4>
              <h5>{key.visitor.type}</h5>
            </div>
            <h4>{key.count}</h4>
          </div>
          <div style={{ height: "1px", backgroundColor: "grey" }}></div>
        </div>
      ))}
    </div>
  );
}

export default DashboardCard;
